import { Injectable} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { SupplierContactBE } from '../../app/supplier-contact/shared/supplier-contact.model';
import { MailingListBE } from './shared/supplier-mass-mail.model';

@Injectable()
export class SupplierMassMailService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'Supplier';

    getMailAddressList(supplierId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetMailAddressList/?id=${supplierId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getAllMailAddressesList(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetAllMailAddressesList`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    sendMassMail( mailingList: MailingListBE[]): Observable<IReturnObject>{
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(mailingList);
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/sendMassMail`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }
}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/supplier-mass-mail/supplier-mass-mail.service.ts